module.exports = __webpack_public_path__ + "media/prk/assets/images/logo-19211f0d7e44c41c27ec8bbfa88fed20.svg";